<div fxLayout="column" class="graphs">
  <div class="graph-principal">
    <ngx-charts-line-chart fix-margin
                           [scheme]="colorScheme"
                           [legend]="principals.legend"
                           [showXAxisLabel]="principals.showXAxisLabel"
                           [showYAxisLabel]="principals.showYAxisLabel"
                           [xAxis]="principals.xAxis"
                           [yAxis]="principals.yAxis"
                           [xAxisLabel]="principals.xAxisLabel"
                           [yAxisLabel]="principals.yAxisLabel"
                           [xAxisTicks]="principals.xAxisTicks"
                           [timeline]="principals.timeline"
                           [yAxisTickFormatting]="(showLog)? powScaleYValue : linearScaleYValue"
                           [results]="principals.line"
    >
      <ng-template #tooltipTemplate let-model="model">
        <span class="tooltip-label">{{model.series}} • {{model.name}}</span>
        <span class="tooltip-val">{{model.origValue}}</span>
      </ng-template>
      <ng-template #seriesTooltipTemplate let-model="model">
        <span class="tooltip-label" *ngFor="let series of model">
          {{series.series}}: {{series.origValue}}
        </span>
      </ng-template>
    </ngx-charts-line-chart>
  </div>
  <div class="graph-interest">
    <ngx-charts-line-chart fix-margin
                           [scheme]="colorScheme"
                           [legend]="interests.legend"
                           [showXAxisLabel]="interests.showXAxisLabel"
                           [showYAxisLabel]="interests.showYAxisLabel"
                           [xAxis]="interests.xAxis"
                           [yAxis]="interests.yAxis"
                           [xAxisLabel]="interests.xAxisLabel"
                           [yAxisLabel]="interests.yAxisLabel"
                           [xAxisTicks]="interests.xAxisTicks"
                           [timeline]="interests.timeline"
                           [yAxisTickFormatting]="(showLog)? powScaleYValue : linearScaleYValue"
                           [results]="interests.line"
    >

      <ng-template #tooltipTemplate let-model="model">
        <span class="tooltip-label">{{model.series}} • {{model.name}}</span>
        <span class="tooltip-val">{{model.origValue}}</span>
      </ng-template>
      <ng-template #seriesTooltipTemplate let-model="model">
      <span class="tooltip-label" *ngFor="let series of model">
        {{series.series}}: {{series.origValue}}
      </span>
      </ng-template>
    </ngx-charts-line-chart>
  </div>
  <div class="graph-expenses">
    <ngx-charts-line-chart fix-margin
                           [scheme]="colorScheme"
                           [legend]="expenses.legend"
                           [showXAxisLabel]="expenses.showXAxisLabel"
                           [showYAxisLabel]="expenses.showYAxisLabel"
                           [xAxis]="expenses.xAxis"
                           [yAxis]="expenses.yAxis"
                           [xAxisLabel]="expenses.xAxisLabel"
                           [yAxisLabel]="expenses.yAxisLabel"
                           [xAxisTicks]="expenses.xAxisTicks"
                           [timeline]="expenses.timeline"
                           [yAxisTickFormatting]="(showLog)? powScaleYValue : linearScaleYValue"
                           [results]="expenses.line"
    >

      <ng-template #tooltipTemplate let-model="model">
        <span class="tooltip-label">{{model.series}} • {{model.name}}</span>
        <span class="tooltip-val">{{model.origValue}}</span>
      </ng-template>
      <ng-template #seriesTooltipTemplate let-model="model">
      <span class="tooltip-label" *ngFor="let series of model">
        {{series.series}}: {{series.origValue}}
      </span>
      </ng-template>
    </ngx-charts-line-chart>
  </div>
</div>
